<template>
    <v-container fluid align-start ma-0 pa-2 class="hycot302-main container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle" :useBtnList="['btnReceiptRequest', 'btnSubmitQuot','btnRequestList']"
                    :unUseBtnList="unUseBtnList" @btnSubmitQuot="btnSubmitQuot" @btnReceiptRequest="btnReceiptRequest" @btnRequestList="btnRequestList">
                    <template v-slot:body>
                        <v-row no-gutters>
                            <v-col cols="3" class="px-1">
                                <i-label :label="'Basic Information : '" />
                            </v-col>
                            <v-col cols="9" align="right" class="pa-1"
                                :style="headerData.receiveYn != null && headerData.receiveYn === 'Y' ? 'display: none;' : ''">
                                <span class="pa-1 subTitle2">[Not yet Received]</span>
                            </v-col>
                        </v-row>
                        <v-row dense class="form-layout">
                            <v-col cols="12" class="pa-0">
                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Quotation No</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-row no-gutters class="row__select-no">
                                            <v-col cols="7">
                                                <v-select v-model="selectedQuot" :items="quotList" item-value="quotNo"
                                                    item-text="quotNo" label="Select No" return-object single-line outlined
                                                    dense @change="quotNoChange"></v-select>
                                            </v-col>
                                            <v-col cols="5" class="pl-2 pt-1 quotNo">
                                                {{ quotStepGbn }}
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Title</span>
                                    </v-col>
                                    <v-col cols="8">
                                        <v-text-field v-model="headerData.quotTitle" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Start Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.stDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Finish Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.fiDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Recieve Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.receiveDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Submit Date</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.submitDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Contract From</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.frDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Contract To</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="headerData.toDte" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>Money Unit</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <!-- <v-select v-model="moneyUnit" :items="moneyUnitList" item-value="code"
                                            item-text="codeName" label="Select No" return-object single-line outlined dense
                                            height="32" /> -->
                                        <v-text-field v-model="headerData.moneUnit" dense outlined hide-details="auto"
                                                    readonly />
                                    </v-col>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>VAT </span>
                                    </v-col>
                                    <v-col cols="2">
                                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                                                    <span class="px-3">
                                                        *****
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <v-select v-model="vatAmt" :items="vatAmtList" item-value="code"
                                                        item-text="codeName" label="Select No" return-object single-line outlined
                                                        dense height="32" />
                                                </template>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                        <span>PIC Remark</span>
                                    </v-col>
                                    <v-col cols="9">
                                        <v-text-field v-model="headerData.picRmk" dense outlined hide-details="auto"
                                            readonly />
                                    </v-col>
                                    <v-col cols="2" align="center" class="pr-2 pt-1 formHeader">
                                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn">
                                            <div :style="filePath != null && filePath != '' ? '' : 'display:none;'">
                                                <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing"
                                                    @click="fileOpen">View Attached File</span>
                                            </div>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="12" class="pt-1">
                                <DxDataGrid id="hycot302" :ref="hycot302Ref" class="hipGridHeight5_2"
                                    :data-source="dataList" :remote-operations="false" :hover-state-enabled="true"
                                    :allow-column-resizing="true" :allow-column-reordering="true"
                                    :row-alternation-enabled="true" :show-borders="true" :width="grid.width"
                                    :show-row-lines="true" key-expr="id" :focused-row-enabled="false"
                                    :column-hiding-enabled="false" :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                    :repaint-changes-only="true">
                                    <DxEditing :use-icons="true" mode="cell" />
                                    <DxColumn data-field="no" caption="No" width="5%" data-type="string" alignment="center"
                                        :allow-editing="false" />
                                    <DxColumn data-field="trsCd" caption="Type" width="10%" data-type="string"
                                        alignment="center" :allow-editing="false" />
                                    <DxColumn data-field="div" caption="Division" width="10%" data-type="string"
                                        alignment="center" :allow-editing="false" />
                                    <DxColumn data-field="trsNm" caption="Items" width="15%" data-type="string"
                                        alignment="center" :allow-editing="false" />
                                     <DxColumn data-field="piAmt" caption="PI Amount" width="15%" data-type="number" format="#,###"
                                        alignment="center" :allow-editing="false" />
                                    <DxColumn data-field="amt" caption="Amount" width="15%" data-type="string"
                                        :format="format" alignment="right" :allow-editing="editGbn === '0'"
                                        :editor-options="{ maxLength: 12 }"
                                        :cell-template="editGbn === '2' ? 'quotAmtTemplate' : ''" />
                                    <DxColumn data-field="rmk" caption="Remark" width="30%" data-type="string"
                                        alignment="left" :allow-editing="editGbn === '0'"
                                        :cell-template="editGbn === '2' ? 'rmkTemplate' : ''" />

                                    <template #quotAmtTemplate>
                                        ************
                                    </template>
                                    <template #rmkTemplate>
                                        *************************
                                    </template>

                                    <DxPaging :enabled="true" />
                                    <!-- <DxPager :visible="false" /> -->
                                </DxDataGrid>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="3" class="px-1">
                                <i-label :label="'File Information : '" />
                            </v-col>
                        </v-row>
                        <v-row v-for="row in 2" :key="'file__row_' + row" no-gutters style="height: 42px;">
                            <v-col v-for="col in 2" :key="'file__row_' + row + '__col_' + col" cols="6"
                                :style="{ 'border-width': `${row === 1 ? '1px' : '0px'} 1px 1px ${col === 1 ? '1px' : '0px'}`, 'border-style': 'solid', 'border-color': 'gray' }">
                                <template v-if="getFileGbn(getFileIdx(row, col)) === '1'">
                                    <v-row no-gutters>
                                        <span class="subTitle pa-2 pr-0">{{ getFileIdx(row, col) + '. ' }}</span>
                                        <v-col cols="4">
                                            <v-file-input class="pa-0" placeholder="File input"
                                                v-model="fileList[getFileIdx(row, col) - 1].fileName"></v-file-input>
                                        </v-col>
                                        <span class="subTitle pt-2 pl-4">Description :</span>
                                        <v-col cols="full" class="pa-1">
                                            <v-text-field dense outlined hide-details="auto" clearable height="32"
                                                v-model="fileList[getFileIdx(row, col) - 1].fileDesc" />
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="fileGbn1 === '3'">
                                    <v-row no-gutters class="align-center">
                                        <span class="subTitle pa-2">{{ getFileIdx(row, col) + '. ' }}</span>
                                        <a
                                            @click.stop="ftpDownload(fileList[getFileIdx(row, col) - 1].linkPath, fileList[getFileIdx(row, col) - 1].fileDesc)">
                                            {{ fileList[getFileIdx(row, col) - 1].fileDesc }}
                                        </a>
                                    </v-row>
                                </template>
                                <template v-else-if="fileGbn1 === '4'">
                                    <v-row no-gutters>
                                        <span class="subTitle pa-2 pr-0">{{ `${getFileIdx(row, col) + '. '
                                            }${fileList[getFileIdx(row, col) - 1].fileDesc ? fileList[getFileIdx(row, col) -
                                                1].fileDesc : ''}${fileList[getFileIdx(row, col) - 1].fileName ? '(' +
                                                    fileList[getFileIdx(row, col) - 1].fileName + ')' : ''}` }}</span>
                                    </v-row>
                                </template>
                            </v-col>
                        </v-row>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getDateFormat, getNumComma, toNum } from '@/utils/common.js'
import notify from 'devextreme/ui/notify'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getSubmitFile, getQuotNoList, getRequestHead, ftpDownload, goReceive, getSubmitDetail } from '@/api/view/hycot/common/common'
import { submitQuot } from '@/api/view/hycot/3/hycot303'

export default {
    name: 'hycot302',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        DxDataGrid,
        DxColumn,
        DxEditing
    },
    data() {
        return {
            menuTitle: this.$route.meta.title,
            hycot302Ref: 'hycot302Ref',
            selectedQuot: null,
            headerData: {},
            quotStepGbn: '',
            quotList: [],
            dataList: [],
            unUseBtnList: [],
            vatAmtList: [],
            vatAmt: null,
            moneyUnitList: [],
            moneyUnit: null,
            editGbn: '0', // 0, 1, 2
            format: '#,##0.############',
            fileList: [
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null }
            ],
            fileGbn1: '0',
            fileGbn2: '0',
            fileGbn3: '0',
            fileGbn4: '0',
            filePath: ''
        }
    },
    computed: {
        gridInstance() {
            return this.GetDataGrid(this.hycot302Ref)
        },
    },
    methods: {
        initData() {
            this.headerData = {
                receiveYn: 'N',
                submitYn: 'N',
                printYn: 'N',
                quotStep: 'B1'
            }
            this.quotStepGbn = ''
            this.dataList = []
            this.unUseBtnList = []
            this.vatAmt = this.vatAmtList[0]
            this.moneyUnit = this.moneyUnitList[0]
            this.editGbn = '0'
            this.fileList = [
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
                { fileDesc: null, fileName: null, fileSeq: null, linkPath: null }
            ]
            this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '0'
        },
        async getCmmCd() {
            await getCmChildCode({
                code: '',
                codegr: '',
                prtCode: 'VAT_AMT',
                userFlag: 'Y'
            }).then(res => {
                this.vatAmtList = res.list
                this.vatAmt = this.vatAmtList[0]
            })

            await getCmChildCode({
                code: '',
                codegr: '',
                prtCode: 'MNY_UNIT',
                userFlag: 'Y'
            }).then(res => {
                this.moneyUnitList = res.list
                this.moneyUnit = this.moneyUnitList[0]
            })
        },
        async getQuotNoList() {
            const param = {
                makerCd: this.$store.state.user.makerCd,
                quotStep: 'B',
                quotDiv: 'L'
            }

            await getQuotNoList(param).then(res => {
                // console.log('res', res)

                const setVal = res.list.find(element => element.quotNo === this.$route.params.quotNo)

                this.quotList = res.list
                this.selectedQuot = setVal
                this.quotNoChange(setVal)
            })
        },
        quotNoChange(e) {
            if (e) {
                switch (e.quotStep) {
                    case 'B2': this.quotStepGbn = '2nd Price Indication'
                        break
                    default: this.quotStepGbn = ''
                        break
                }

                this.getQuotData()
            }
        },
        async getQuotData() {
            try {
                this.initData()
                this.openLoading('searching')

                const param = {

                    quotNo: this.selectedQuot.quotNo,
                    quotStep: this.selectedQuot.quotStep,
                    makerCd: this.$store.state.user.makerCd,
                    quotDiv: 'L'
                }

                await getRequestHead(param).then(res => {
                    console.log('headRes', res)

                    if (res.list.length > 0) {

                        switch (res.list[0].quotStep) {
                             case 'B2': this.quotStepGbn = '2nd Price Indication'
                                break
                            default: this.quotStepGbn = ''
                                break
                        }
                        this.headerData = res.list[0]
                        this.filePath = res.list[0].filePath
                        this.headerData.quotDiv = 'L'
                        if (!this.headerData.submitYn || this.headerData.submitYn === 'N') {
                            this.editGbn = '0'
                        } else if (!this.headerData.printYn || this.headerData.printYn === 'N') {
                            this.editGbn = '1'
                        } else {
                            this.editGbn = '2'
                        }
                    }
                })

                await getSubmitDetail(param).then(res => {

                    console.log('submitDetailRes', res)

                    let data = res.list
                    for (let i = 0; i < data.length; i++) {
                        data[i].id = data[i].no = i + 1
                    }
                    this.dataList = data

                })


                await getSubmitFile(param).then(res => {
                    // console.log('fileRes', res)

                    for (let i = 0; i < res.list.length; i++) {
                        this.fileList[i].fileName = res.list[i].fileName
                        this.fileList[i].fileDesc = res.list[i].fileDesc
                        this.fileList[i].fileSeq = res.list[i].fileSeq
                        this.fileList[i].linkPath = res.list[i].linkPath
                    }

                    if (!this.headerData.submitYn || this.headerData.submitYn === 'N') {
                        this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '1'
                    } else {
                        for (let i = 0; i < this.fileList.length; i++) {
                            if (!this.fileList[i].fileName) {
                                this[`fileGbn${i + 1}`] = '2'
                                continue
                            }

                            if (!this.headerData.printYn || this.headerData.printYn === 'N') {
                                this[`fileGbn${i + 1}`] = '3'
                                continue
                            }

                            this[`fileGbn${i + 1}`] = '4'
                        }
                    }

                    // console.log('this.fileGbn1', this.fileGbn1)
                    // console.log('this.fileGbn2', this.fileGbn2)
                    // console.log('this.fileGbn3', this.fileGbn3)
                    // console.log('this.fileGbn4', this.fileGbn4)
                })

                this.setBtnList()
            } finally {
                this.endLoading()
            }
        },
        getFileGbn(gbn) {
            return this['fileGbn' + gbn]
        },
        getFileIdx(row, col) {
            return row * col + (col < row ? row - 1 : 0)
        },
        getDateFormat(date) {
            return getDateFormat(date)
        },
        getNumComma(val) {
            return getNumComma(val)
        },
        async btnSubmitQuot() {
            const vm = this

            await this.gridInstance.saveEditData()
            // this.fncCalcTotal()

            const makerCd = this.$store.state.user.makerCd

            if (!this.selectedQuot || !this.selectedQuot.quotNo) {
                this.vToastify(this.$t('There is no quotation no.'), 'warn')
                return
            } else if (this.headerData.submitYn === 'Y') {
                return
            } else if (this.headerData.receiveYn !== 'Y') {
                this.vToastify(this.$t('Not yet Received'), 'warn')
                return
            }

            let prms = true

            let cnt = 0
            let totalAmt = 0

            for (let i = 0; i < this.dataList.length; i++) {
                this.dataList[i].rmk = !this.dataList[i].rmk ? '' : this.dataList[i].rmk
                totalAmt += this.dataList[i].amt
                cnt += !this.dataList[i].rmk ? 0 : 1

            }

            if (totalAmt * 1 === 0) {
                if (cnt == 0) {
                    this.vToastify(this.$t('Cannot submit.<br>PI Amount is 0 and Remarks is null.'), 'warn')
                    return
                }
            }

            if (this.vatAmt.code == 0) {
                await new Promise(function (resolve, reject) {
                    vm.vToastifyPrompt(
                        vm.$t('VAT is 0.<br>Continue?'),
                        'info',
                        current => {
                            prms = true
                            resolve()
                        },
                        current => {
                            prms = false
                            resolve()
                        },
                        false
                    )
                })
            }


            if (!prms) {
                return
            }

            for (let i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].fileName && !this.fileList[i].fileDesc) {
                    this.vToastify(this.$t(`Input File${i + 1} description.`), 'warn')
                    return
                }
            }


            this.vToastifyPrompt(
                this.$t('Do you want to submit the Transport PI?'),
                'info',
                current => {
                    const formData = new FormData()

                    this.headerData.makerCd = this.$store.state.user.makerCd
                    this.headerData.vatAmt = this.vatAmt.code
                    this.headerData.moneUnit = this.moneyUnit.code
                    this.headerData.userId = this.$store.state.user.userId
                    this.headerData.userIp = this.$store.state.user.userIp
                    formData.append('masterData', JSON.stringify(this.headerData))
                    formData.append('detailData', JSON.stringify(this.dataList))

                    for (let i = 0; i < this.fileList.length; i++) {
                        if (this.fileList[i].fileName) {
                            formData.append('files', this.fileList[i].fileName)
                            formData.append('fileDescs', this.fileList[i].fileDesc)
                        }
                    }

                    // console.log('masterData', formData.getAll('masterData'))
                    // console.log('detailData', formData.getAll('detailData'))
                    // console.log('files', formData.getAll('files'))
                    // console.log('fileDescs', formData.getAll('fileDescs'))

                    this.openLoading()
                    submitQuot(formData).then(res => {
                        // console.log('submitQuotRes', res)

                        const result = res.body
                        if (result === 'OK') {
                            this.quotNoChange(this.selectedQuot)
                            notify(this.$t(' PI Submit is completed.'), 'success', 3000)
                        } else {
                            this.vToastify(this.$t(result), 'warn')
                        }
                    }).catch(error => {
                        this.vToastify(error, 'warn')
                    }).finally(() => {
                        this.endLoading()
                    })
                },
                null,
                false
            )

        },
        setBtnList() {

            if (this.headerData.receiveYn === 'Y') {
                this.unUseBtnList.push('btnReceiptRequest')
            }

            if (this.headerData.submitYn === 'Y') {
                this.unUseBtnList.push('btnSubmitQuot')
            }
        },
        btnReceiptRequest() {
            if (this.headerData.receiveYn && this.headerData.receiveYn === 'Y') {
                return
            }

            if (!this.selectedQuot || !this.selectedQuot.quotNo) {
                this.vToastify(this.$t('There is no data for receive the PI Request.'), 'warn')
                return
            }

            this.vToastifyPrompt(
                this.$t('Do you want to receive the PI Request?'),
                'info',
                current => {
                    this.openLoading('searching')

                    const param = {
                        quotNo: this.selectedQuot.quotNo,
                        makerCd: this.$store.state.user.makerCd
                    }

                    goReceive(param).then(res => {
                        // console.log('res', res)

                        const msg = res.body
                        if (msg === 'OK') {
                            notify(this.$t('Receipt PI is completed.'), 'success', 3000)

                            this.quotNoChange(this.selectedQuot)
                        } else {
                            this.vToastify(this.$t(msg), 'warn')
                        }
                    }).catch(error => {
                        this.vToastify(error, 'warn')
                    }).finally(() => {
                        this.endLoading()
                    })
                },
                null,
                true
            )
        },
        fileOpen(e) {
            let file = this.filePath

            //this.openLoading('searching')
            // ftpDownload(file)
            //   .finally(() => {
            //     this.endLoading()
            //   })

            ftpDownload(this.filePath);

        },
        ftpDownload(filePath, fileName) {
            this.openLoading()
            ftpDownload(filePath, fileName).finally(() => {
                this.endLoading()
            })
        },
        btnRequestList() {

            console.log('push')

             this.$router.push({
                    name: 'hycot301'
                })
        }
        
    },
    mounted() {
        this.getCmmCd()
        this.getQuotNoList()
    }
}
</script>
<style lang="scss" scoped>
$redBtn: #FF0000;

.form-layout::v-deep .col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;

    * {
        border: 0px none !important;
    }

    .row:not(.row__select-no) {
        border-width: 0 0 1px 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }

    .col:not(.quotNo) {
        border-width: 0 1px 0 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }
}

.formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    // border: 1px solid gray;
    color: black;
    font-size: 9pt;
}

.formHeader2 {
    background-color: rgb(214, 243, 247);
}

.subTitle {
    font-weight: bold;
    color: black;
}

.subTitle2 {
    font-weight: bold;
    color: red;
}

.quotNo {
    font-weight: bold;
    border: 1px solid gray;
    border-bottom: 0px;
    color: #0000FF;
    font-size: 9pt;
}

::v-deep {
    [role=btnSubmitQuot] {
        :not([disabled=disabled]) {
            .v-btn__content {

                div,
                i {
                    color: #{$redBtn} !important;
                }
            }
        }
    }
}
</style>